
import Opportunity from '@/models/Opportunity'
import ViewModel from '@/models/ViewModel'
import WebMessage from '@/models/WebMessage'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class CrmProgress extends ViewModel {
  @Prop()
  public value!: any

  @Prop({ default: false })
  public disabled!: boolean

  @Prop({ default: '' })
  public mainPlan!: string

  @Prop({ default: false })
  public isLoading!: any

  @Prop()
  public progressStatus!: any

  public original_status: any = null

  public opportunity_status: any = Opportunity.opportunity_status

  @Prop({ required: true })
  public opportunity!: Opportunity

  /**
   * @deprecated
   * for reference only, delete after review
   */
  public old_updateOnClick(clicked_status: any) {
    // 1. Won e lost nunca pode ser alterado.
    let automated_status = ['won', 'lost']

    if (automated_status.includes(this.progressStatus)) {
      WebMessage.warning(
        'The status can not be updated, it will be automatically updated with the media plan.',
      )
      return
    }
    /// ///////////////////////

    // 2. WON nunca pode ser movido manualmente. Automático, quando MP é confirmado confirmado.
    if (clicked_status.code === 'won') {
      WebMessage.warning(
        'Can not set to Won, the status will be automatically updated once the media plan is confirmed or canceled.',
      )
      return
    }

    this.$emit('input', clicked_status.value)
    this.$emit('update:progressStatus', clicked_status.code)

    // 3. Qualquer outro estágio que não seja WON, ele pode mover para lost, desde que não tenha nenhum impression no Media Plan (Mesma logica do home)
    if (clicked_status.code !== 'lost') {
      this.original_status = clicked_status
    } else {
      this.$emit(clicked_status.code, {
        old_status: this.original_status,
      })
    }
  }

  public async updateOnClick({ code, value }: { code: string; value: number }) {
    try {
      //
      this.loading = true
      let can_change = await this.opportunity.changeStage({ code, value })
      if (can_change) {
        this.$emit('input', value)
        this.$emit('update:progressStatus', code)
      }
    } catch (error) {
      // console.error('CrmProgress.updateOnClick', error)
      this.loading = false
    } finally {
      this.loading = false
    }
  }

  public lowerCase(s: any) {
    if (!s) return ''
    return s.toLowerCase()
  }

  mounted() {
    this.original_status = this.opportunity_status.find(
      (status: any) => status.value === this.value,
    )
  }
}
